import { Alert, Autocomplete, Box, Button, Divider, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, Switch, TextField } from '@mui/material';
import React, { Component } from 'react';
import axios from 'axios';
import Global from '../../customlib/Global';
import Api from '../../customlib/Api';
import { Warning } from '@mui/icons-material';

class InputFiveWhys extends Component {
    state = { 
        customer: {},
        isSaving: false,
        errorMessage: "",
        showTodoConfirmation: false,
        toggleApprovalDisabled: true,
        listCity: [],
        productCategories: [],
    } 

    initFiveWhysObject = {
        _id: "",
        id: "",
        contactObjectId: "",
        leadObjectId: "",
        issue: "",
        from: "",
        fromName: "",
        userId: 0,
        userName: "",
        whys: [{why: "why 1", why_value: ""}, {why: "why 2", why_value: ""}, {why: "why 3", why_value: ""}, {why: "why 4", why_value: ""}, {why: "why 5", why_value: ""}, ],
        issueDescription: "",
        solution: "",
        issueCategory: "",
        todo: "",
        status: "NOT APPROVED",
        statusPenyelesaian: "OPEN",
        productCategory: "",
        cityName: "",
        cityId: 0,
        priceRange: "",
        lavenderProductCategory: 0,
        action: ""
    };

    componentDidMount() {
        
        let customerData = this.props.data ?? null;
        if(customerData && !this.props.data?.five_whys){
            customerData.five_whys = this.initFiveWhysObject;
        }else{
            customerData.five_whys.id = customerData.five_whys._id
        }
        this.setState({customer: customerData}, () => {
            console.log("INPUT_FIVE",this.state.customer);
            this.toggleApprovalDisabled();
            this.loadProductCategories();
            this.getCityList();
        });
        
    }

    getCityList = () =>{
        let params = {
        };
        
        axios
          .post(Api.getCityList(), params, Api.getRequestHeader())
          .then((response) => {
            console.log("CITYLIST",response.data);
    
            let cityList = response.data.data;
            this.setState({listCity: cityList});
          })
          .catch((error) => {
            this.setState({ errorMessage: error.message });
            console.error("There was an error!", error);
          });
    }

    loadProductCategories = () => {
        axios
            .get(Api.lavenderGetProductCategories(), Api.getRequestHeaderNoAuth())
            .then((response) => {
            let categories = response.data.categories;
            categories.forEach(item => {
                item.label = item.name;
            });

            this.setState({productCategories: categories});
            })
            .catch((error) => {
            console.error("There was an error!", error);
            });
    };

    handleUpdateWhy = (event, index) => {
        console.log("INPUT_FIVE", index, event.target.value, this.state.customer?.five_whys?.issueCategory, this.state.customer?.five_whys?.todo);

        let customer = {...this.state.customer};
        let whys = customer.five_whys.whys;

        whys[index].why_value = event.target.value;

        this.setState({customer: customer});

    }

    handleIssueChange = (event) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.five_whys;

        fiveWhys.issue = event.target.value;

        this.setState({customer: customer});
    }

    handleIssueDescriptionChange = (event) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.five_whys;

        fiveWhys.issueDescription = event.target.value;

        this.setState({customer: customer});
    }

    handleActionChange = (event) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.five_whys;

        fiveWhys.action = event.target.value;

        this.setState({customer: customer});
    }

    handleSolutionChange = (event) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.five_whys;

        fiveWhys.solution = event.target.value;

        this.setState({customer: customer});
    }

    handleIssueCategoryChange = (event) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.five_whys;

        fiveWhys.issueCategory = event.target.value;

        this.setState({customer: customer});
    }

    handleTodoChange = (event) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.five_whys;

        fiveWhys.todo = event.target.value;

        this.setState({customer: customer});
    }
    
    handleStatusChange = (event) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.five_whys;

        fiveWhys.status = event.target.checked ? "APPROVED" : "NOT APPROVED";

        this.setState({customer: customer});
    }

    handleSaveFiveWhys = () => {
      
        this.setState({isSaving: true}, ()=>{
        const params = {...this.state.customer.five_whys};
        params.leadObjectId = this.state.customer._id;
        params.contactObjectId = this.state.customer._id;
        params.from = this.state.customer.from;
        params.fromName = this.state.customer.fromName;
        params.userId = Global.get().user.id;
        params.userName = Global.get().user.name;
        params.lavenderProductCategory = params.lavenderProductCategory?.id ?? 0;
        console.log("INPUT_FIVE", params);
        // return;
        axios
            .post(Api.saveFiveWhys(), params, Api.getRequestHeader())
            .then((response) => {
            console.log("YOUR_MESSAGES",response.data);
            
            let responseData = response.data;
            if(responseData.success){
                this.setState({ errorMessage: "", isSaving: false }, () => {
                    this.props.onReload();
                    this.props.onClose(null);
                });
            }else{
                this.setState({ errorMessage: responseData.message, isSaving: false });
            }
            
            })
            .catch((error) => {
                this.setState({ errorMessage: error.message, isSaving: false });
                console.error("There was an error!", error);
            });
        });
    
        
    };

    toggleApprovalDisabled = () => {

        let isDisabled = true;

        if(this.state.customer.five_whys._id && this.state.customer.five_whys._id.length > 0){
            isDisabled = false; 
        }

        let isAdmin = Global.get().admin;
        let isAdminTeleUser = Global.isAdminTeleUser();
        let isTeleAdmin = Global.isTeleAdmin();

        console.log("INPUT_FIVE_DATA", this.state.customer.five_whys);
        console.log("INPUT_FIVE_admin", isAdmin, isAdminTeleUser, isTeleAdmin);

        if(isAdmin || isAdminTeleUser || isTeleAdmin){
            if(this.state.customer.five_whys.status === "APPROVED"){
                isDisabled = true;
            }else{
                isDisabled = false;                
            }
        }

        this.setState({toggleApprovalDisabled: isDisabled});

        return isDisabled;
    }

    handleHideTodoConfirmation = () => {
        this.setState({showTodoConfirmation: false});
    }

    handleShowTodoConfirmation = () => {
        this.setState({showTodoConfirmation: true});
    }

    handleProductCategoryChange = (event) => {
        let obCustomer = {...this.state.customer};
        obCustomer.productCategory = event.target.value
        this.setState({customer: obCustomer});
    }

    handlePriceRangeChange = (event) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.five_whys;
        fiveWhys.priceRange = event.target.value
        this.setState({customer: customer});
    }

    handleCityOnChange = (newCity) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.five_whys;
        
        let selected = this.state.listCity.filter((city) => city.name===newCity);
    
        if(selected.length > 0){
            fiveWhys.cityName = selected[0].name;
            fiveWhys.cityId = selected[0].id;
            this.setState({customer: customer}, () => {
            console.log("SELECTED CITY", selected[0]);
          });
        }   
    }

    handleCategoryChange = (event, newValue) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.five_whys;
        let findCategory = this.state.productCategories?.find(item => item.label === newValue.label);
        console.log("LOG___cate", findCategory, "NEWVALUE : ", newValue, "DATA", customer);
        fiveWhys.lavenderProductCategory = findCategory;
        if(findCategory){
            this.setState({customer: customer});
        }
    }

    render() { 
        return (
            <Box>
                {
                    this.state.errorMessage && this.state.errorMessage.length > 0 && 
                    <Alert variant='filled' icon={<Warning fontSize="inherit" />} severity="error">
                        {this.state.errorMessage}
                    </Alert>
                }
                <Box sx={{fontWeight: "bold"}}>Customer : {this.state.customer?.fromName}</Box>
                {/* <Grid container spacing={1}>
                    <Grid item xs={2}>Customer</Grid> 
                    <Grid item xs={10}>: {this.state.customer?.fromName}</Grid> 
                </Grid> */}
                
                <FormControl fullWidth size='small' sx={{mt: "10px"}}>
                    <TextField
                    id="txt-issue"
                    label="Issue"
                    multiline
                    maxRows={4}
                    onChange={this.handleIssueChange}
                    value={this.state.customer?.five_whys?.issue}
                    size='small'
                    />
                </FormControl>

                <Grid container spacing={1}>
                    {
                        this.state.customer && this.state.customer?.five_whys && this.state.customer?.five_whys?.whys.map((item, index) => {
                            return <Grid item xs={index+1 === this.state.customer?.five_whys?.whys.length ? 12 : 6}>
                                <FormControl fullWidth size='small' sx={{mt: "10px"}}>
                                    <TextField
                                    id={`txt-why-${index}`}
                                    label={`Why ${index+1}`}
                                    multiline
                                    maxRows={4}
                                    onChange={(event) => this.handleUpdateWhy(event, index)}
                                    value={item.why_value}
                                    size='small'
                                    />
                                </FormControl>
                            </Grid>
                        })
                    }
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                    <FormControl fullWidth size='small' sx={{mt: "10px"}}>
                        <TextField
                        id="txt-issue-description"
                        label="Issue Description"
                        multiline
                        maxRows={4}
                        onChange={this.handleIssueDescriptionChange}
                        value={this.state.customer?.five_whys?.issueDescription}
                        size='small'
                        />
                    </FormControl>
                    </Grid> 
                    <Grid item xs={6}>
                    <FormControl fullWidth size='small' sx={{mt: "10px"}}>
                        <TextField
                        id="txt-solution"
                        label="Solution"
                        multiline
                        maxRows={4}
                        onChange={this.handleSolutionChange}
                        value={this.state.customer?.five_whys?.solution}
                        size='small'
                        />
                    </FormControl>
                    </Grid> 
                </Grid>

                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <FormControl fullWidth size='small' sx={{mt: "10px"}}>
                            <InputLabel id="issue-category">Issue category</InputLabel>
                            <Select
                                labelId={"issue-category"}
                                id={"select-issue-category"}
                                value={this.state.customer?.five_whys?.issueCategory}
                                defaultValue={this.state.customer?.five_whys?.issueCategory}
                                // value={"Sales"}
                                label="Issue category"
                                onChange={this.handleIssueCategoryChange}
                                size='small'
                                // sx={{fontSize: "12px"}}
                            >
                                <MenuItem value={"Mitra"}>Mitra</MenuItem>
                                <MenuItem value={"Produk"}>Produk</MenuItem>
                                <MenuItem value={"Respon Diluar Jam Kerja"}>Respon Diluar Jam Kerja</MenuItem>
                                <MenuItem value={"Respon Jam Kerja"}>Respon Jam Kerja</MenuItem>
                                <MenuItem value={"Harga"}>Harga</MenuItem>
                                <MenuItem value={"Tidak Jadi Pesan"}>Tidak Jadi Pesan</MenuItem>
                                <MenuItem value={"Tidak Ada Di Katalog"}>Tidak Ada Di Katalog</MenuItem>
                                <MenuItem value={"Sales"}>Sales</MenuItem>
                                <MenuItem value={"Estimasi Waktu"}>Estimasi Waktu</MenuItem>
                                <MenuItem value={"Admin"}>Admin</MenuItem>
                                <MenuItem value={"Product Catalog"}>Product Catalog</MenuItem>
                                <MenuItem value={"Jarak"}>Jarak</MenuItem>
                            </Select>
                        </FormControl>
                        <Autocomplete
                            // disablePortal
                            id="auto-kategori-produk"
                            options={this.state.productCategories}
                            renderInput={(params) => <TextField {...params} label="Kategori Produk" />}
                            onChange={(event, newValue) => this.handleCategoryChange(event, newValue)}
                            onInputChange={(event, newValue) => this.handleCategoryChange(event, newValue)}
                            // autoHighlight
                            // freeSolo={true}
                            size='small'
                            sx={{mt: "15px"}}
                        />
                        {/* <FormControl size="small" variant="outlined" style={{width: '100%', marginTop: "15px"}}>
                            <InputLabel id="demo-simple-select-outlined-label">Pilih Kategori Produk</InputLabel>
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={this.state.customer.productCategory}
                                onChange={this.handleProductCategoryChange}
                                label="Kategori Produk"
                            >
                            {
                                Global.getListProductCategories().map(
                                (cat) => {
                                    return (<MenuItem key={cat} value={cat}>{cat}</MenuItem>);
                                } 
                                )
                            }
                            </Select>
                        </FormControl> */}

                        <Autocomplete
                            id="free-solo-2-demo"
                            // disableClearable
                            freeSolo 
                            options={this.state.listCity.map((option) => {
                                return String(option.name);
                            })}
                            onChange={(event, newValue) => {
                                this.handleCityOnChange(newValue);
                            }} 
                            value={this.state.customer?.five_whys?.cityName}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Pilih Kota"
                                margin="0"
                                variant="outlined"
                                InputProps={{ ...params.InputProps, type: 'search' }}
                            />
                            )}
                            size="small"
                            sx={{marginTop: "15px"}}
                        />

                        <FormControl size="small" variant="outlined" style={{width: '100%', marginTop: "15px"}}>
                            <InputLabel id="demo-simple-select-outlined-label">Range Harga</InputLabel>
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={this.state.customer?.five_whys?.priceRange}
                                onChange={this.handlePriceRangeChange}
                                label="Range Harga"
                            >
                                {
                                Global.getPriceRange().map(
                                    (cat) => {
                                    return (<MenuItem key={cat} value={cat}>{cat}</MenuItem>);
                                    } 
                                )
                                }
                            </Select>
                        </FormControl>
                    </Grid> 
                    <Grid item xs={6}>
                        <FormControl fullWidth size='small' sx={{mt: "10px"}}>
                            <InputLabel id="todo">To Do</InputLabel>
                            <Select
                                labelId={"todo"}
                                id={"select-todo"}
                                value={this.state.customer?.five_whys?.todo}
                                label="Hasil Fu"
                                onChange={this.handleTodoChange}
                                size='small'
                                // sx={{fontSize: "12px"}}
                            >
                                <MenuItem value={"HR"}>HR</MenuItem>
                                <MenuItem value={"Finance"}>Finance</MenuItem>
                                <MenuItem value={"IT"}>IT</MenuItem>
                                <MenuItem value={"Akuisisi"}>Akuisisi</MenuItem>
                                <MenuItem value={"Supply Chain"}>Supply Chain</MenuItem>
                                <MenuItem value={"Module Training"}>Module Training</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl fullWidth size='small' sx={{mt: "10px"}}>
                            <TextField
                                id="txt-action"
                                label="Action"
                                multiline
                                maxRows={4}
                                onChange={this.handleActionChange}
                                value={this.state.customer?.five_whys?.action}
                                size='small'
                            />
                        </FormControl>
                    </Grid> 
                </Grid>

                <Divider sx={{mt: "10px", mb: "10px"}} />

                <Box sx={{textAlign: "right"}}>
                    <Grid container spacing={1}>
                        <Grid item xs={4} sx={{textAlign: "left"}}>
                            <FormControlLabel disabled={this.state.toggleApprovalDisabled} control={<Switch defaultChecked />} label={this.state.customer?.five_whys?.status === "APPROVED" ? "Approved" : "Not Approved"} onChange={this.handleStatusChange} checked={this.state.customer?.five_whys?.status === "APPROVED"} />
                        </Grid>
                        <Grid item xs={8}>
                            {
                                this.state.showTodoConfirmation && (
                                    <Box>
                                        <Alert 
                                            variant='filled'
                                            icon={<Warning fontSize="inherit" />} 
                                            severity="error" 
                                            action={
                                            <Box>
                                                <Button onClick={this.handleSaveFiveWhys} variant='contained' color="primary" size="small">
                                                    Ya, Sesuai
                                                </Button>
                                                &nbsp;
                                                <Button onClick={this.handleHideTodoConfirmation} variant='contained' color="warning" size="small">
                                                    Batal
                                                </Button>
                                            </Box>
                                        }>
                                            Apakah To Do sudah benar-benar sesuai?
                                        </Alert>
                                    </Box>
                                )
                            }
                            {
                                !this.state.showTodoConfirmation && <Button color='primary' variant='contained' size='small' onClick={this.handleShowTodoConfirmation} disabled={this.state.isSaving}>Simpan</Button>
                            }
                            
                            &nbsp;
                            {
                                !this.state.showTodoConfirmation && <Button color='error' variant='contained' size='small' onClick={() => this.props.onClose(null)}>Tutup</Button>
                            }
                            
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        );
    }
}
 
export default InputFiveWhys;